import React from 'react';
import { Button } from 'ui-toolkit/index';
import { TaxCertificationDelinquency } from './TaxCertificationDelinquency';
import {
  createDefaultTaxCertificationDelinquenciesData,
  ITaxCertificationDelinquenciesData,
} from 'ui-toolkit/taxCertifications/ITaxCertificationDelinquencies';
import { ITaxCertificationData } from 'ui-toolkit/taxCertifications/ITaxCertification';
import { Field, FieldArray } from 'formik';
import { NewOrderSpaceWrapping } from '../../orderCreation/wrappers/NewOrderSpaceWrapper';
import { IFieldChildProps } from '../../../ui-toolkit/utilities/formikUtilities';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';

export interface ITaxCertificationDelinquenciesProps {
  baseName: string;
}

export const TaxCertificationDelinquencies: React.FC<ITaxCertificationDelinquenciesProps> = ({ baseName }) => {
  return (
    <Field name={baseName}>
      {({ field }: IFieldChildProps<ITaxCertificationDelinquenciesData[], ITaxCertificationData>) => (
        <FieldArray name={baseName}>
          {({ remove, push }) => (
            <>
              {field.value.map((item, index) => (
                <TaxCertificationDelinquency
                  key={`delinquency.${item.id}`}
                  baseName={`${baseName}.${index}`}
                  index={index}
                  canDelete={field.value.length > 1}
                  onRemove={() => remove(index)}
                />
              ))}
              <NewOrderSpaceWrapping>
                <Button
                  intent="secondary"
                  type={'button'}
                  onClick={() => push(createDefaultTaxCertificationDelinquenciesData())}
                  data-test-id={mergeTests(baseName, `add`)}
                >
                  + Add Tax Year Information
                </Button>
              </NewOrderSpaceWrapping>
            </>
          )}
        </FieldArray>
      )}
    </Field>
  );
};
